import { useState } from "react";
import { X } from "lucide-react";
import { advanceGate } from "../../lib/api";
import ModalScrim from "../ModalScrim";

export function G8CloseModal({ app, onClose, onSubmit }) {
  const [actualTco, setActualTco] = useState("");
  const [actualSavings, setActualSavings] = useState("");
  const [actualRoi, setActualRoi] = useState("");
  const [kpi, setKpi] = useState("");
  const [cause, setCause] = useState("");
  const [validation, setValidation] = useState("");
  const [outcome, setOutcome] = useState("MEASURED");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const measured = outcome === "MEASURED";
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await onSubmit({
        actual_tco: measured ? actualTco : undefined,
        actual_savings: measured ? actualSavings : undefined,
        actual_roi: measured && actualRoi ? Number(actualRoi) : null,
        kpi_realization: kpi,
        variance_cause: cause.trim() || undefined,
        business_validation: validation,
        outcome_state: outcome,
      });
    } catch (ex) {
      setErr(ex.response?.data?.detail || "G8 closure failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <ModalScrim>
      <form className="modal wide" onSubmit={submit}>
        <button type="button" className="modal-close" onClick={onClose}><X size={18} /></button>
        <p className="kicker">G8 · BUSINESS VALIDATION EVIDENCE</p>
        <h2>Close G8 · {app.name}</h2>
        <p className="muted">Deployment ≠ Production success. MEASURED requires typed actuals — expected TCO is not copied.</p>
        <label>G8 outcome state
          <select data-testid="g8-outcome-state" value={outcome} onChange={(e) => setOutcome(e.target.value)}>
            {["MEASURED", "UNKNOWN", "DEFERRED", "NOT_ACHIEVED"].map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
        <label>Actual monthly TCO / annualized cost<input data-testid="g8-actual-tco" required={measured} value={actualTco} onChange={(e) => setActualTco(e.target.value)} placeholder="$1.6M" /></label>
        <label>Actual savings realised<input data-testid="g8-actual-savings" required={measured} value={actualSavings} onChange={(e) => setActualSavings(e.target.value)} placeholder="$1.2M" /></label>
        <label>Actual ROI (%)<input data-testid="g8-actual-roi" type="number" value={actualRoi} onChange={(e) => setActualRoi(e.target.value)} /></label>
        <label>KPI realisation summary<textarea data-testid="g8-kpi" rows={2} required={measured} value={kpi} onChange={(e) => setKpi(e.target.value)} placeholder="Deploy freq 4× · CFR 8% · Availability 99.6%" /></label>
        <label>Variance cause<textarea data-testid="g8-variance-cause" rows={2} value={cause} onChange={(e) => setCause(e.target.value)} /></label>
        <label>Business validation source<input data-testid="g8-validation-source" required={measured} value={validation} onChange={(e) => setValidation(e.target.value)} /></label>
        {err && <div className="error-message" data-testid="g8-error">{err}</div>}
        <button data-testid="confirm-g8-close" className="primary-button full" type="submit" disabled={busy}>{busy ? "Recording G8…" : measured ? "Record actuals & PASS G8" : `Record G8 as ${outcome}`}</button>
      </form>
    </ModalScrim>
  );
}

export function GateSignoffModal({ gateId, appId, onClose, onDone }) {
  const [name, setName] = useState("Alex Morgan");
  const [role, setRole] = useState(gateId === "G5" ? "Security Architect" : "Enterprise Architect");
  const [note, setNote] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await advanceGate(appId, gateId, { approver: name, role, note });
      onDone();
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Sign-off failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <ModalScrim>
      <form className="modal wide" onSubmit={submit}>
        <button type="button" className="modal-close" onClick={onClose}><X size={18} /></button>
        <p className="kicker">GATE SIGN-OFF · {gateId}</p>
        <h2>Confirm {gateId} evidence</h2>
        <p className="muted">Only a configured decision authority can advance a protected gate.</p>
        <label>Approver<input data-testid={`signoff-name-${gateId}`} required value={name} onChange={(e) => setName(e.target.value)} /></label>
        <label>Authority role
          <select data-testid={`signoff-role-${gateId}`} value={role} onChange={(e) => setRole(e.target.value)}>
            {["Enterprise Architect", "Solution Architect", "Security Architect", "Product Owner", "Business Owner", "Modernization Lead"].map((r) => (
              <option key={r} value={r}>{r}</option>
            ))}
          </select>
        </label>
        <label>Evidence note<textarea data-testid={`signoff-note-${gateId}`} rows={2} value={note} onChange={(e) => setNote(e.target.value)} /></label>
        {err && <div className="error-message" data-testid={`signoff-error-${gateId}`}>{err}</div>}
        <button data-testid={`confirm-signoff-${gateId}`} className="primary-button full" type="submit" disabled={busy}>{busy ? "Signing off…" : `Confirm ${gateId} PASS`}</button>
      </form>
    </ModalScrim>
  );
}
